import { CaretRight } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

import MemberPermissionsTag from "common/components/MemberPermissionsTag";
import WorkspaceImage from "common/components/WorkspaceImage";
import type { Workspace } from "common/types";

export default function WorkspaceItem({ workspace }: { workspace: Workspace }) {
  const {
    id,
    name,
    accounts_count: accountsCount,
    icon_url,
    role,
    permissions,
  } = workspace;

  return (
    <Link
      to={`/workspaces/${id}`}
      className="flex items-center gap-2.5 rounded-3xl border border-black-200 bg-white p-3 transition-colors hover:bg-black-50"
    >
      <WorkspaceImage id={id} imageSrc={icon_url} />
      <div className="flex flex-col items-start gap-y-1 flex-1">
        <span className="text-md-bold">{name}</span>

        <span className="text-xs-medium text-black-500">
          {accountsCount
            ? `${accountsCount} account${accountsCount > 1 ? "s" : ""}`
            : "No accounts"}
        </span>
      </div>
      <MemberPermissionsTag role={role} permissions={permissions} />
      <CaretRight className="ml-1.5 size-5" />
    </Link>
  );
}
